// @ts-nocheck
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Box,
  Modal,
  Step,
  StepLabel,
  Stepper,
  Typography,
  stepConnectorClasses,
  StepConnector,
  Grid,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import styled from "@emotion/styled";
import AddContractorFormStep1 from "./AddContractorForms/AddContractorFormStep1";
import ReusableParentContainer from "../../../components/Custom/ReusableParentContainer";
import AddContractorFormStep2 from "./AddContractorForms/AddContractorFormStep2";
import AddContractorFormStep3 from "./AddContractorForms/AddContractorFormStep3";

import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import AddContractorCongratulations from "./AddContractorForms/AddContractorCongratulations";
import {
  CLEAR_ADD_CONTRACTOR,
  SETUP_EDIT_CONTRACTOR_SUCCESS,
} from "../../../store/constants/contractor";

import addContractorModalStyles from "./addContractorModal.module.css";
import {
  getEmailSanitized,
  phoneNumberFormat,
} from "../../../utils/methods/formatters";
import AddContractorFormStep2_1 from "./AddContractorForms/AddContractorFormStep2_1";
import { BarToggle } from "../../../components/Others/BarToggle";
import { width } from "@mui/system";
import { isUserRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";

const getStepBackgroundColor = (num) => {
  switch (num) {
    case 1:
      return "#D175B6";
    case 2:
      return "#6C61B0";
    case 3:
      return "#0087D1";
    case 4:
      return "#00A4CC";
    case 5:
      return "#00BFCD";
    case 6:
      return "#61D6DE";
  }
};

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState, number }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#110b25",
  border: `2px solid ${getStepBackgroundColor(number)}`,
  zIndex: 1,
  color: getStepBackgroundColor(number),
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  "& p": {
    fontSize: "1.35rem",
    color: `${getStepBackgroundColor(number)}`,
  },
  "& svg path": {
    color: getStepBackgroundColor(number),
    stroke: getStepBackgroundColor(number),
  },
  ...(ownerState.active && {
    backgroundColor: getStepBackgroundColor(number),
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    "& svg path": {
      color: getStepBackgroundColor(number),
      stroke: getStepBackgroundColor(number),
    },
    "& p": {
      fontSize: "1.35rem",
      color: `#fff`,
    },
  }),
  ...(ownerState.completed && {
    backgroundColor: getStepBackgroundColor(number),
    "& svg path": {
      color: getStepBackgroundColor(number),
      stroke: getStepBackgroundColor(number),
    },
    "& p": {
      fontSize: "1.35rem",
      color: `#fff`,
    },
  }),
}));

const ColorlibConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 25,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#D175B6",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#D175B6",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#D175B6",
    borderRadius: 1,
  },
}));

const ColorlibStepIcon = (props) => {
  const { active, completed, className } = props;

  const icons = {
    1: <Typography>1</Typography>,
    2: <Typography>2</Typography>,
    3: <Typography>3</Typography>,
    4: <Typography>4</Typography>,
    5: <Typography>5</Typography>,
    6: <Typography>6</Typography>,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
      number={props.icon}
    >
      <Box sx={{ color: `${getStepBackgroundColor(props.icon)} !important` }}>
        {icons[props.icon]}
      </Box>
    </ColorlibStepIconRoot>
  );
};

const FormParentContainer = ({ children }) => {
  return (
    <Box
      sx={{
        height: "70%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: "1",
        gap: "10px",
      }}
    >
      {children}
    </Box>
  );
};

const FormDataBox = ({ children, style, className }) => {
  return (
    <Box
      className={`${addContractorModalStyles.formDataBox} ${className}`}
      sx={{
        ...(style || {}),
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          height: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
        // className={'custom-scroll-design'}
      >
        {children}
      </Grid>
    </Box>
  );
};

const prefillEditContractorFlowHandler = ({
  dispatch,
  contractor,
  allPositions,
}) => {
  dispatch({
    type: SETUP_EDIT_CONTRACTOR_SUCCESS,
    payload: {
      step1: {
        submitFormRequestLoading: false,
        data: contractor,
        form: {
          firstName: contractor?.firstName || "",
          middleName: contractor?.middleName || "",
          lastName: contractor?.lastName || "",
          preferredName: contractor?.preferredName || "",
          mobile: phoneNumberFormat(contractor?.mobile) || "",
          email: getEmailSanitized({ email: contractor?.email }) || "",
          mailingAddress: contractor?.mailingAddress || "",
          city: contractor?.city || "",
          state: contractor?.state || "",
          zipCode: contractor?.zipCode || "",
          dateOfBirth: contractor?.dateOfBirth || "",
          age: contractor?.age || "",
          emergencyContactName: contractor?.emergencyContactName || "",
          emergencyContactNumber:
            phoneNumberFormat(contractor?.emergencyContactNumber) || "",
          einNumber: contractor?.einNumber || "",
          profileId: contractor?.profileId || "",
          workBookId: contractor?.workBookId || "",
          preferredCities: contractor?.preferredCities || [],
          preferredStates: contractor?.preferredStates || [],
          preferredAirportIds:
            contractor?.preferredAirportIds?.length > 0
              ? contractor?.preferredAirportIds
              : [{ Id: {}, radius: 50 }],
          additionalAirportIds:
            contractor?.additionalAirportIds?.length > 0
              ? contractor?.additionalAirportIds
              : [{ Id: {}, radius: 50 }],
          companyName: contractor?.companyName || "",
          thirdPartyContractorId: contractor?.thirdPartyContractorId || null,
          contractorType: contractor?.contractorType,
        },
        previouslySubmittedForm: {
          firstName: contractor?.firstName || "",
          middleName: contractor?.middleName || "",
          lastName: contractor?.lastName || "",
          preferredName: contractor?.preferredName || "",
          mobile: phoneNumberFormat(contractor?.mobile) || "",
          email: getEmailSanitized({ email: contractor?.email }) || "",
          mailingAddress: contractor?.mailingAddress || "",
          city: contractor?.city || "",
          state: contractor?.state || "",
          zipCode: contractor?.zipCode || "",
          dateOfBirth: contractor?.dateOfBirth || "",
          age: contractor?.age || "",
          emergencyContactName: contractor?.emergencyContactName || "",
          emergencyContactNumber:
            phoneNumberFormat(contractor?.emergencyContactNumber) || "",
          einNumber: contractor?.einNumber || "",
          profileId: contractor?.profileId || "",
          workBookId: contractor?.workBookId || "",
          preferredCities: contractor?.preferredCities || [],
          preferredStates: contractor?.preferredStates || [],
          preferredAirportIds:
            contractor?.preferredAirportIds?.length > 0
              ? contractor?.preferredAirportIds
              : [{ Id: {}, radius: 50 }],
          additionalAirportIds:
            contractor?.additionalAirportIds?.length > 0
              ? contractor?.additionalAirportIds
              : [{ Id: {}, radius: 50 }],
          companyName: contractor?.companyName || "",
          thirdPartyContractorId: contractor?.thirdPartyContractorId || null,
          contractorType: contractor?.contractorType,
        },
      },
      step2: {
        submitFormRequestLoading: false,
        data: contractor,
        form: {
          rolesWorked: contractor?.rolesWorked,
          roleExperience: contractor?.roleExperience,
          preferredPiecesOfGear: contractor?.preferredPiecesOfGear,
          certificatesAccreditations: contractor?.certificatesAccreditations,
        },
        previouslySubmittedForm: {
          rolesWorked: contractor?.rolesWorked,
          roleExperience: contractor?.roleExperience,
          preferredPiecesOfGear: contractor?.preferredPiecesOfGear,
          certificatesAccreditations: contractor?.certificatesAccreditations,
        },
      },
      step3: {
        submitFormRequestLoading: false,
        data: contractor,
        form: {
          careerHighlights: contractor?.careerHighlights,
          professionalGoals: contractor?.professionalGoals,
        },
        previouslySubmittedForm: {
          careerHighlights: contractor?.careerHighlights,
          professionalGoals: contractor?.professionalGoals,
        },
      },
      step4: {
        submitFormRequestLoading: false,
        data: contractor,
        form: {
          roleExperience: allPositions?.map?.((position) => {
            const filteredRole = contractor?.roleExperience?.filter?.(
              (role) => {
                return role?.role === position?.positionName;
              },
            )?.[0];
            return {
              _id: position._id,
              role: position?.positionName,
              experience: filteredRole?.experience || 0,
            };
          }),
        },
        previouslySubmittedForm: {
          roleExperience: allPositions?.map?.((position) => {
            const filteredRole = contractor?.roleExperience?.filter?.(
              (role) => {
                return role?.role === position?.positionName;
              },
            )?.[0];
            return {
              _id: position._id,
              role: position?.positionName,
              experience: filteredRole?.experience || 0,
            };
          }),
        },
      },
      step5: {
        submitFormRequestLoading: false,
        data: contractor,
        form: null,
        previouslySubmittedForm: null,
      },
    },
  });
};

const AddContractorModal = ({
  showAddContractorsModal,
  closeAddContractorModalHandler,
  heading,
  isEditing,
  isViewing,
  lastStepHeading,
  stepNo,
  successCallbacks,
  subHeading,
}) => {
  // Static data start...
  // const countryCode = 'US';

  // const statesOptions = React.useMemo(() => {
  //     const country = Country.getCountryByCode(countryCode);
  //     return State.getStatesOfCountry(country.isoCode)?.map(state => {
  //         return {
  //             label: state?.name,
  //             value: state?.isoCode,
  //         }
  //     });
  // }, []);
  const lastStep = 6;
  // Static data end...

  // media query hooks...
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // media query hooks...

  // Redux hooks start...
  const dispatch = useDispatch();
  // Redux hooks end...

  // Selectors start...
  const contractor = useSelector((store) => store.contractor);
  // Selectors end...

  // State variables start...
  const [currentStep, setCurrentStep] = React.useState(1);
  const [isThirdPartyParent, setIsThirdPartyParent] = useState(
    isEditing || isViewing ? undefined : false,
  );
  // const [initialValues, setInitialValues] = React.useState({
  //     firstName: '',
  //     lastName: '',
  //     mobile: '',
  //     email: '',
  //     mailingAddress: '',
  //     city: '',
  //     state: '',
  //     zipCode: '',
  //     einNumber: '',
  //     companyName: ''
  // });
  // State variables end...

  // Form schema...
  // const formSchema = Yup.object().shape({
  //     firstName: Yup.string().required("FirstName is required!"),
  //     lastName: Yup.string().required("LastName is required!"),
  //     mobile: Yup.string().required("Phone Number is required!"),
  //     email: Yup.string().required("Email is required!"),
  //     mailingAddress: Yup.string().required("Mailing Address is required!"),
  //     city: Yup.string().required("City is required!"),
  //     state: Yup.string().required("State is required!"),
  //     zipCode: Yup.string().required("Zipcode is required!"),
  //     einNumber: Yup.string().required("EIN Number is required!"),
  //     companyName: Yup.string().required("Company Name is required!")
  // })

  // const formik = useFormik({
  //     initialValues,
  //     validationSchema: formSchema,
  //     onSubmit: (values) => {

  //         const payload = {
  //             ...values,
  //             state: State.getStateByCodeAndCountry(values.state, countryCode).name
  //         }

  //         dispatch(
  //             addContractorStep1Action({
  //                 payload,
  //                 formData: values,
  //                 successCallback: () => {
  //                     resetForm();
  //                     setCurrentStep(2);
  //                 },
  //                 afterResponseCallback: () => {
  //                 }
  //             })
  //         );
  //         console.log(payload, values.state, 'submitted');
  //     }
  // });

  // const {
  //     values, setValues, setFieldValue, dirty, handleChange, handleBlur, touched, errors, submitForm,
  //     resetForm
  // } = formik;
  // Form schema...

  // Handlers start...
  // const getCitiesOfAState = (stateCode) => {
  //     const cities = City.getCitiesOfState(countryCode, stateCode);

  //     return cities?.map(city => {
  //         return {
  //             label: city?.name,
  //             value: city?.name
  //         }
  //     })
  // };

  const submitFormHandler = (callback) => {
    if (callback) {
      callback();
    }
  };

  const resetContractorFlowHandler = () => {
    dispatch({
      type: CLEAR_ADD_CONTRACTOR,
    });
    setCurrentStep(1);
  };

  const closeAndResetContractorFlowHandler = () => {
    // setShowAddContractorsModal(false);
    closeAddContractorModalHandler();
    dispatch({
      type: CLEAR_ADD_CONTRACTOR,
    });
    setCurrentStep(1);
    // dispatch(fetchContractorsAction({
    //     params: {
    //         page: 1
    //     }
    // }));
  };

  const closeModalHandler = () => {
    // setShowAddContractorsModal(false);
    if (currentStep < 4) {
      // setShowAddContractorsModal(false);
      if (isViewing || isEditing) {
        closeAndResetContractorFlowHandler();
      }
      closeAddContractorModalHandler();
    } else {
      closeAndResetContractorFlowHandler();
    }
    // closeAddContractorModalHandler();
  };
  // Handlers end...

  // useEffects start...
  // React.useEffect(() => {
  //     setFieldValue(
  //         'city',
  //         'Select city'
  //     )
  // }, [values?.state, setFieldValue]);

  // React.useEffect(() => {
  //     if (contractor?.addContractor?.step1?.form) {
  //         setValues(contractor?.addContractor?.step1?.form);
  //         setInitialValues(contractor?.addContractor?.step1?.form);
  //     }
  // }, []);

  React.useEffect(() => {
    if (currentStep === lastStep && isViewing) {
      closeAndResetContractorFlowHandler();
    }
  }, [currentStep]);

  React.useEffect(() => {
    if (stepNo > 0) {
      setCurrentStep(stepNo);
    }
  }, [stepNo]);
  // useEffects end...

  const showContracts = useMemo(() => {
    const contractorType =
      contractor?.addContractor?.step1?.data?.contractorType;
    const isVerified = contractor?.addContractor?.step1?.data?.isApproved;

    const haveContract = ["V.C.", "1099", "w2"]?.includes(contractorType);

    return haveContract && isVerified && (isViewing || isEditing);
  }, [
    isViewing,
    isEditing,
    contractor?.addContractor?.step1?.data?.contractorType,
    contractor?.addContractor?.step1?.data?.isApproved,
  ]);

  return (
    <Modal
      open={showAddContractorsModal}
      onClose={() => {
        closeModalHandler();
      }}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        visibility:
          currentStep === lastStep && isViewing ? "hidden" : "visible",
      }}
    >
      <Box
        sx={{
          width: isMediumScreen ? "95%" : "70%",
          maxWidth: "900px",
          height: isViewing && currentStep === 5 ? "auto" : isSmallScreen ? "90%" : currentStep === 5 ? "80%" : "auto",
          maxHeight: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ReusableParentContainer
          style={{
            padding: "2rem",
            background: "rgb(0, 0, 0)",
            alignItems: "flex-start",
            color: getCssVariableHandler({
              variableName: "--font-rgb",
            }),
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              width: "95%",
              height: `100%`,
              // padding: '30px 0',
              display: "flex",
              flexDirection: "column",
              // justifyContent: 'center',
              gap: "35px",
              "& > *": {
                width: "100%",
              },
            }}
          >
            {(isEditing || isViewing) &&
            !contractor?.addContractor?.contractorData?.loaded ? (
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress size={22} />
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    position: "relative",
                    display: "flex",
                    // justifyContent:
                    //   isSmallScreen && !isViewing && !isEditing
                    //     ? "space-between"
                    //     : "center",
                    alignItems: "center",
                    flexDirection: "column",
                    // flexDirection: isMediumScreen ? "column" : "row"
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      textAlign: "center",
                      // alignSelf: isMediumScreen ? "center" : "flex-start",
                    }}
                  >
                    {heading}
                  </Typography>

                  {/* {!isViewing && !isEditing ? ( */}
                  {/*   <Button */}
                  {/*     sx={{ */}
                  {/*       position: isSmallScreen ? "relative" : "absolute", */}
                  {/*       top: isSmallScreen ? "0" : "50%", */}
                  {/*       right: "0", */}
                  {/*       transform: isSmallScreen ? "none" : "translateY(-50%)", */}
                  {/*       minWidth: "0 !important", */}
                  {/*       padding: "0.5rem 1.5rem !important", */}
                  {/*       borderRadius: "0.5rem", */}
                  {/*     }} */}
                  {/*     className="btn-pink" */}
                  {/*     onClick={() => { */}
                  {/*       dispatch({ */}
                  {/*         type: ALERT_DIALOG, */}
                  {/*         payload: { */}
                  {/*           open: true, */}
                  {/*           title: "Alert", */}
                  {/*           message: "Are you sure you want to reset the form?", */}
                  {/*           onOk: resetContractorFlowHandler, */}
                  {/*         }, */}
                  {/*       }); */}
                  {/*     }} */}
                  {/*   > */}
                  {/*     Reset */}
                  {/*   </Button> */}
                  {/* ) : null} */}
                </Box>

                <Stepper
                  alternativeLabel
                  activeStep={currentStep - 1}
                  connector={<ColorlibConnector />}
                  sx={{
                    marginInline: "auto",
                    // padding:"0 60px",
                    width: "70%",
                    "@media (max-width: 600px)": {
                      width: "100%",
                      textAlign: "center",
                    },
                  }}
                >
                  <Step key={1}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                      {""}
                    </StepLabel>
                  </Step>
                  <Step key={2}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                      {""}
                    </StepLabel>
                  </Step>
                  <Step key={3}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                      {""}
                    </StepLabel>
                  </Step>
                  <Step key={4}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                      {""}
                    </StepLabel>
                  </Step>
                  {/* <Step key={5}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                      {""}
                    </StepLabel>
                  </Step> */}
                  <Step key={6}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                      {""}
                    </StepLabel>
                  </Step>
                </Stepper>

                <Box
                  sx={{
                    height: "70%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: "1",
                    gap: "10px",
                  }}
                >
                  {currentStep === 1 ? (
                    <AddContractorFormStep1
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      // setShowAddContractorsModal={setShowAddContractorsModal}
                      closeModalHandler={closeModalHandler}
                      FormDataBox={FormDataBox}
                      uiController={{
                        showBottomBtnBox: true,
                      }}
                      isEditing={isEditing}
                      isViewing={isViewing}
                      successCallbackStep1={
                        successCallbacks?.successCallbackStep1
                      }
                      isThirdPartyParent={isThirdPartyParent}
                    />
                  ) : null}

                  {currentStep === 2 ? (
                    <AddContractorFormStep2
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      FormDataBox={FormDataBox}
                      uiController={{
                        showBottomBtnBox: true,
                      }}
                      isEditing={isEditing}
                      isViewing={isViewing}
                      successCallbackStep2={
                        successCallbacks?.successCallbackStep2
                      }
                    />
                  ) : null}

                  {currentStep === 3 ? (
                    <AddContractorFormStep2_1
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      FormDataBox={FormDataBox}
                      uiController={{
                        showBottomBtnBox: true,
                      }}
                      isEditing={isEditing}
                      isViewing={isViewing}
                      successCallbackStep2={
                        successCallbacks?.successCallbackStep2
                      }
                    />
                  ) : null}

                  {currentStep === 4 ? (
                    <AddContractorFormStep3
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      FormDataBox={FormDataBox}
                      uiController={{
                        showBottomBtnBox: true,
                      }}
                      isEditing={isEditing}
                      isViewing={isViewing}
                      successCallbackStep3={
                        successCallbacks?.successCallbackStep3
                      }
                    />
                  ) : null}

                  {/* {currentStep === 5 ? (
                    <AddContractorFormStep4
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      FormDataBox={FormDataBox}
                      uiController={{
                        showBottomBtnBox: true,
                      }}
                      isEditing={isEditing}
                      isViewing={isViewing}
                      successCallbackStep4={
                        successCallbacks?.successCallbackStep4
                      }
                    />
                  ) : null} */}

                  {currentStep === 5 ? (
                    <AddContractorCongratulations
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      closeAndResetContractorFlowHandler={
                        closeAndResetContractorFlowHandler
                      }
                      subHeading={subHeading}
                      isEditing={isEditing}
                      heading={lastStepHeading}
                      successCallbackStep5={
                        successCallbacks?.successCallbackStep5
                      }
                      showContracts={showContracts}
                      isViewing={isViewing}
                    />
                  ) : null}
                </Box>
              </>
            )}
          </Box>
        </ReusableParentContainer>
      </Box>
    </Modal>
  );
};

AddContractorModal.propTypes = {
  showAddContractorsModal: PropTypes.bool,
  // setShowAddContractorsModal: PropTypes.func,
  closeAddContractorModalHandler: PropTypes.func,
  heading: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isViewing: PropTypes.bool.isRequired,
  lastStepHeading: PropTypes.string,
  stepNo: PropTypes.number,
  successCallbacks: PropTypes.func,
  subHeading: PropTypes.node || null,
  isThirdPartyParent: PropTypes.bool || null,
};

FormParentContainer.propTypes = {
  children: PropTypes.node,
};

export default AddContractorModal;
export { prefillEditContractorFlowHandler };
